import React from "react";
import PropTypes from "prop-types";
import Notification from "~/assets/js/components/Notification";
import i18n from "~/assets/js/Helpers/i18n";

const AcceptTermsNotification = ({ open }) => {
    if (!open) {
        return null;
    }

    return (
        <Notification type="danger" icon>
            {i18n.t("overview.acceptTerms")}
        </Notification>
    );
};

AcceptTermsNotification.propTypes = {
    open: PropTypes.bool.isRequired,
};

export default AcceptTermsNotification;
